"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _actiontypes = _interopRequireDefault(require("./actiontypes"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Our initial state we use to hydrate
var initialState = {
  showVersions: false,
  environment: 'prd'
}; // Here be our reducer for the Component Shell module.
// Expects the current state and an action. Returns a *new* state object
// based on the action.

var componentShellReducer = function componentShellReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _actiontypes["default"].SHOW_FULFILLMENT_CONFIGURATIONS_LIST:
      return _objectSpread(_objectSpread({}, state), {}, {
        showVersions: false
      });

    case _actiontypes["default"].SHOW_VERSIONS_LIST:
      return _objectSpread(_objectSpread({}, state), {}, {
        showVersions: true
      });

    case _actiontypes["default"].SETTING_ENVIRONMENT:
      return _objectSpread(_objectSpread({}, state), {}, {
        environment: action.environment
      });

    default:
      return state;
  }
};

var _default = componentShellReducer;
exports["default"] = _default;